import { defineFcm } from '../shared/factory';

export const FCM_PROMOTIONS_INELIGIBLE_PETITION_REFUNDS_ENABLED = defineFcm(
	'promotions_ineligible_petition_refunds_enabled',
)
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-site-platform',
		scope: 'promotion-service',
		context: 'Automated Refunds on Closed / Hidden Petitions - Promotion Service',
		description: `Enables / Disables the 60 day automated refunds for closed / hidden petitions.
			When a petition is closed or hidden the RefundIneligiblePetition worker is queued up to refund the petition in 60 days.
			At the time of processing the petition, this FCM is checked to see if automated refunds are still enabled.`,
	});
